/*
 * @Author: zl
 * @Date: 2022-09-15 16:08:20
 * @LastEditTime: 2022-12-09 17:01:57
 * @LastEditors: zl
 * @Description: 审计报表
 */
import request from '@/api/request'

// 审计报表 - 统计总数数据
export const selectTotalStatistics = function (data) {
    return request({
        url: '/auditDataSummary/selectTotalStatistics',
        method: 'post',
        data
    })
}

// 审计报表-统计列表数据
export const selectAuditStatement = function (data) {
    return request({
        url: '/auditDataSummary/selectAuditStatement',
        method: 'post',
        data
    })
}

// 审计意见单-获取详情
export const selectViewBillDetail = function (data) {
    return request({
        url: '/viewBill/selectViewBillDetail',
        method: 'post',
        data
    })
}

// 审计监督-获取详情
export const selectSuperviseDetail = function (data) {
    return request({
        url: '/auditSupervise/selectSuperviseDetail',
        method: 'post',
        data
    })
}

// 审计方案-获取详情
export const selectSchemeDetail = function (data) {
    return request({
        url: '/auditScheme/selectSchemeDetail',
        method: 'post',
        data
    })
}

// 审计日志-获取详情
export const selectWorkLogDetail = function (data) {
    return request({
        url: '/workLog/selectWorkLogDetail',
        method: 'post',
        data
    })
}

// 会议纪要-获取详情
export const selectMeetSummDetail = function (data) {
    return request({
        url: '/meetingSummary/selectMeetSummDetail',
        method: 'post',
        data
    })
}

// 周报月报-获取详情
export const selectWmReportDetail = function (data) {
    return request({
        url: '/wmReport/selectWmReportDetail',
        method: 'post',
        data
    })
}

// 审计奖罚单-获取详情
export const getAwViTicketInfo = function (data) {
    return request({
        url: '/auditawardviolationticket/getAwViTicketInfo',
        method: 'post',
        data
    })
}

// 现场踏勘记录-查看详情
export const selectInvestRecordDetail = function (data) {
    return request({
        url: '/investRecord/selectInvestRecordDetail',
        method: 'post',
        data
    })
}

// 联系单/变更 - 获取详情
export const selectContactSheetDetail = function (data) {
    return request({
        url: '/contactSheet/selectContactSheetDetail',
        method: 'post',
        data
    })
}

// 签证索赔单-获取详情
export const selectAuditVisaDetail = function (data) {
    return request({
        url: '/auditVisa/selectAuditVisaDetail',
        method: 'post',
        data
    })
}

// 核对纪要-获取详情
export const selectCheckMinutesDetail = function (data) {
    return request({
        url: '/checkMinutes/selectCheckMinutesDetail',
        method: 'post',
        data
    })
}

// 审计报告--获取详情
export const selAuditReportDetail = function (data) {
    return request({
        url: '/auditReport/selAuditReportDetail',
        method: 'post',
        data
    })
}

// 审计报告--获取详情
export const selectTemplateAuditList = function (data) {
    return request({
        url: '/sysTemplateAudit/selectTemplateAuditList',
        method: 'post',
        data
    })
}
